<template>
  <div id="bound" class="text-center" v-if="user.email_verified">
    <p>{{ $t('email') }}{{ $t(':') }}{{ user.email }}</p>
    <p><img src="/static/img/dashboard/ic_verified.svg" alt="Your email"><span>{{ $t('bound') }}</span></p>
  </div>

  <div class="bind-form" v-else>
    <div class="form-group">
      <input type="email" name="email" v-model.trim="email"
             :class="[{'danger-border': showEmailError && emailHasError}, 'email']"
             :placeholder="$t('email')"
             v-validate="'required|email'"
             @focus="showEmailError = false"
             @blur="showEmailError = true"
             @keyup.enter="bindEmail">
      <p class="error-info">
        <span v-show="showEmailError && errors.has('email')">{{ errors.first('email') }}</span>
        <span v-show="showEmailError && !!emailErrorMessage">{{ emailErrorMessage }}</span>
      </p>
    </div>

    <div class="form-group get-verification-code">
      <button>
        <spinner :show="countDown === 0 && getCodeDisabled" class="spinner-component"></spinner>
        <span v-show="countDown === 0 && !getCodeDisabled" @click="getVerificationCode" class="get-code">{{ $t('getVerificationCode') }}</span>
        <span v-show="countDown > 0" class="wait">{{ $t('wait') }} {{ countDown }} s</span>
      </button>

      <input autocomplete="off" type="text" name="verificationCode" v-model.trim="verificationCode"
             :class="{'danger-border': codeHasError}"
             :placeholder="$t('verificationCode')"
             v-validate="'required|numeric|digits: 5'"
             @focus="showCodeError = false"
             @blur="showCodeError = true"
             @keyup.enter="bindEmail">

      <p class="error-info">
        <span v-show="showCodeError && errors.has('verificationCode')">{{ errors.first('verificationCode') }}</span>
        <span v-show="showCodeError && !!codeErrorMessage">{{ codeErrorMessage }}</span>
      </p>
    </div>

    <button v-if="!binding" @click="bindEmail" class="form-submit"><span>{{ $t('bind') }}</span></button>
    <spinner :show="binding" class="spinner-component"></spinner>
  </div>

</template>

<script>
  import Spinner from '../Spinner.vue'
  import locales from './lang'

  export default {
    name: 'bind-email',
    components: {Spinner},
    data: function () {
      return {
        email: '',
        emailErrorMessage: '',
        showEmailError: true,
        countDown: 0,
        getCodeDisabled: false,
        verificationCode: '',
        codeErrorMessage: '',
        showCodeError: true,
        binding: false
      }
    },
    computed: {
      user() {
        return this.$store.state.user
      },
      emailHasError() {
        return this.errors.has('email') || this.emailErrorMessage !== ''
      },
      codeHasError() {
        return this.errors.has('verificationCode') || this.codeErrorMessage !== ''
      }
    },
    watch: {
      countDown() {
        if (this.countDown < 1) {
          this.getCodeDisabled = false
        }
      },
      email() {
        this.showEmailError = false
        this.emailErrorMessage = ''
      },
      verificationCode() {
        this.showCodeError = false
        this.codeErrorMessage = ''
      },
      user() {
        if (this.user.email) {
          this.email = this.user.email
        }
      }
    },
    locales,
    mounted() {
      if (this.user.email) {
        this.email = this.user.email
      }
    },
    methods: {
      getVerificationCode() {
        this.showEmailError = true
        if (this.getCodeDisabled) {
          return
        }
        if (this.emailHasError) {
          this.getCodeDisabled = false
          return
        }
        this.$validator.validateAll({email: this.email}).then(success => {
          if (!success) {
            this.getCodeDisabled = false
            return
          }
          this.getCodeDisabled = true
          this.$http.post('api/verification/email?type=binding', {
            email: this.email
          }).then((response) => {
            this.getCodeDisabled = false
            switch (response.data.code) {
              case 0: {
                this.countDown = 60
                this.runTimer()
                break
              }
              default: {
                this.emailErrorMessage = response.data.message
              }
            }
          })
        })
      },
      bindEmail() {
        this.showCodeError = true
        if (this.errors.length > 0) {
          this.binding = false
          return
        }
        this.$validator.validateAll().then(success => {
          if (!success) {
            this.binding = false
            return
          }
          this.binding = true
          this.$http.patch('api/email/binding', {
            email: this.email,
            verification_code: this.verificationCode
          }).then((response) => {
            this.binding = false
            switch (response.data.code) {
              case 0: {
                this.$store.dispatch('getUserInformation')
                break
              }
              case 110: {
                this.emailErrorMessage = response.data.message
                break
              }
              default: {
                this.codeErrorMessage = response.data.message
              }
            }
          })
        })
      },
      runTimer: function () {
        if (this.countDown > 0) {
          this.countDown--
          setTimeout(this.runTimer, 1000)
        }
      }
    }
  }
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
  @import "../../assets/scss/formstyle";

  #bound {
    color: #111;
    p:first-child {
      margin-bottom: .4rem;
      font-size: .14rem;
      line-height: .2rem;
      letter-spacing: 0.93px;
      @media screen and (max-width: 767px) {
        margin-bottom: .26rem;
      }
    }
    p:last-child {
      font-size: .14rem;
      letter-spacing: .82px;
      line-height: .16rem;
      vertical-align: middle;
      img {
        width: .16rem;
        height: .16rem;
        margin: -.03rem .1rem 0 0;
      }
      @media screen and (max-width: 767px) {
        margin-bottom: .4rem;
        img {
          margin-right: .05rem;
        }
      }
    }
  }

  input::-webkit-contacts-auto-fill-button {
    visibility: hidden;
    display: none !important;
    pointer-events: none;
  }

  .get-verification-code {
    input {
      padding-right: .8rem;
    }
    button {
      position: absolute;
      top: 0;
      right: 0;
      font-size: .12rem;
      line-height: .36rem;
      background: transparent;
      color: #295FFD;
      letter-spacing: 0.7px;
      .spinner-component {
        height: .3rem;
        width: .3rem;
        margin: 0;
      }
    }
  }
  .wait {
    font-size: .12rem;
    color: #BDBDBD;
    letter-spacing: 0.7px;
  }

  div.form-group{
    input{
      background-color: transparent;
      color: #111;
      border-bottom: 1px solid #E0D7E3;
    }
    input::-webkit-input-placeholder{
      color: #999;
    }
  }

  .form-submit{
    width: 260px;
    height: 40px;
    line-height: 40px;
    border: 1px solid #416CF8;
    border-radius: 20px;
    color: #416CF8;
    font-size: .16rem;
    background: #fff;
    @media screen and (max-width: 767px) {
      height: 48px;
      line-height: 48px;
      border-radius: 100px;
      margin-top: .2rem;
    }
  }
</style>



// WEBPACK FOOTER //
// IndexMain.vue?439bb468